import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { TableLinksEncuestas } from './components/TableLinksEncuestas';
import { FormLinksEncuestasModal } from './components/FormLinksEncuestasModal';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../../commons/texts/textAlertsInformativos';
import { BannerInfoLinksEncuestas } from './components/BannerInfoLinksEncuestas';

export const LinksEncuestasPage = () => {
  const [openModalForm, setOpenModalForm] = useState(false);

  const handleOpenForm = () => {
    setOpenModalForm(true);
  };

  const handleCloseForm = () => {
    setOpenModalForm(false);
  };

  return (
    <Box sx={{ p: 3, margin: '0 auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <BreadCrumbsAndTitle
            title="Links de Encuestas"
            mainModule="calificaciones"
            parent="Configuraciones"
            action="Links Encuestas"
            icon="Link"
          />

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <AlertsInformativos
              type={'info'}
              title={'info'}
              content={alertInformativo.linksEncuestas}
            />
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleOpenForm}
        >
          Nuevo Link
        </Button>
      </Box>

      <TableLinksEncuestas />

      <FormLinksEncuestasModal open={openModalForm} onClose={handleCloseForm} />

      <BannerInfoLinksEncuestas />
    </Box>
  );
};
